import { comics, rankingList } from "@/mocks/comics";

export default function Ranking() {
  const coverOf = (title: string) => comics.find((c) => c.title === title)?.cover ?? "";

  return (
    <section id="ranking" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex items-end justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-primary-600">
              <i className="ri-trophy-line"></i> 本周热度
            </span>
            <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-4xl">
              追更榜 TOP 8
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600 md:text-base">
              大家正在追的连载都在这里，热度实时攀升，想找下饭连载就看这份榜单。
            </p>
          </div>
          <a
            href="#featured"
            className="hidden whitespace-nowrap items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 sm:inline-flex"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {rankingList.map((item) => {
            const cover = coverOf(item.title);
            return (
              <div
                key={item.id}
                className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300"
              >
                <span
                  className={`flex h-11 w-11 shrink-0 flex-col items-center justify-center rounded-md ${
                    item.rank <= 3 ? "bg-accent-500 text-background-50" : "bg-background-200 text-foreground-600"
                  }`}
                >
                  <span className="font-heading text-xl leading-none">{item.rank}</span>
                  <span className="text-[9px] uppercase">TOP</span>
                </span>
                <div className="min-w-0 flex-1">
                  <h3 className="truncate text-sm font-bold text-foreground-950">{item.title}</h3>
                  <p className="mt-1 text-xs text-foreground-500">
                    更新于 {item.updateTime}
                  </p>
                  <p className="mt-0.5 flex items-center gap-1 text-xs font-medium text-accent-600">
                    <i className="ri-fire-fill"></i> {(item.hot / 1000).toFixed(1)}k 追更热度
                  </p>
                </div>
                {cover && (
                  <img
                    src={cover}
                    alt={`${item.title}漫画封面小图`}
                    className="hidden h-16 w-12 shrink-0 rounded object-cover object-top sm:block"
                  />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}